var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKebab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.22222222,0 C0.99392333,0 0,0.9939233 0,2.2222222 C0,3.4505211 0.99392333,4.4444444 2.22222222,4.4444444 C3.45052111,4.4444444 4.44444444,3.4505211 4.44444444,2.2222222 C4.44444444,0.9939233 3.45052111,0 2.22222222,0 Z M10,0 C8.7717011,0 7.77777778,0.9939233 7.77777778,2.2222222 C7.77777778,3.4505211 8.7717011,4.4444444 10,4.4444444 C11.2282989,4.4444444 12.2222222,3.4505211 12.2222222,2.2222222 C12.2222222,0.9939233 11.2282989,0 10,0 Z M17.7777778,0 C16.5494789,0 15.5555556,0.9939233 15.5555556,2.2222222 C15.5555556,3.4505211 16.5494789,4.4444444 17.7777778,4.4444444 C19.0060767,4.4444444 20,3.4505211 20,2.2222222 C20,0.9939233 19.0060767,0 17.7777778,0 Z",
    transform: "rotate(-90 16 6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebab);
export default __webpack_public_path__ + "static/media/kebab.80c0b357d639014a6ec86a835da1ba34.svg";
export { ForwardRef as ReactComponent };